import { put, takeLatest, call } from 'redux-saga/effects';

import * as actions from './actions';
import * as types from './types';
import * as service from './service';

function* fetchProjectsPage(action: any) {
    try {
        const params = action.payload;
        const data = yield call(service.fetchProjectsPage, params);

        yield put(actions.fetchProjectsSuccess(data, params));
    } catch (error) {
        yield put(actions.fetchProjectsError(error.message));
    }
}

function* fetchProjectsFilters() {
    try {
        const data = yield call(service.fetchProjectsFilters);

        yield put(actions.fetchProjectsFiltersSuccess(data));
    } catch (error) {
        yield put(actions.fetchProjectsFiltersError(error.message));
    }
}

export default function* appSaga() {
    yield takeLatest(types.FETCH_PROJECTS_PAGE, fetchProjectsPage);
    yield takeLatest(types.FETCH_PROJECTS_FILTERS, fetchProjectsFilters);
}
